import React from 'react';
import { Link, Tooltip } from '@chakra-ui/react';
import { FaBlogger } from 'react-icons/fa'; // ✅ Nuevo icono
import { motion } from 'framer-motion';
import { COLORS } from "../../colors";

const MotionLink = motion(Link);

const BlogButton = () => {
  return (
    <Tooltip label="Visita nuestro blog" placement="left" hasArrow>
      <MotionLink
        href="https://somersetlanguagecentre.blogspot.com/"
        isExternal
        position="fixed"
        bottom="4"
        right="16"
        bg="#f49540" // color Blogger
        color="white"
        rounded="full"
        p={3}
        zIndex="tooltip"
        _hover={{
          bg: '#f9b77c', // hover más claro
        }}
        transition="background-color 0.3s ease"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
      >
        <FaBlogger />
      </MotionLink>
    </Tooltip>
  );
};

export default BlogButton;
